// apiCalls.ts
import {
  ApiRequest,
  Currency,
  Partners,
  Reports,
  LoginInternalLink,
  LoginAuthInterface,
  PatchNote,
  Balance,
  QnARequestArray,
  UpdateQnARequestArray,
} from "../lib/interfaces/index";

import { apiContext } from "../lib/config/EncryptAPIContext";
import { ENDPOINT } from "../lib/enums/index";

export const getCurrencies = async (): Promise<Currency[]> => {
  try {
    const response = await apiContext.get<Currency[]>(`${ENDPOINT.CURRENCY}`);
    return response.data;
  } catch (error) {
    console.error("Error occurred while fetching currencies:", error);
    return [];
  }
};

export const getPartners = async ({ userId }: ApiRequest) => {
  try {
    const response = await apiContext.post<Partners>(
      `${ENDPOINT.REGULARPARTNERS}`,
      {
        userId,
      }
    );
    const { respCode, partners } = response.data;
    if (respCode && respCode === 2000) return partners;
    else return null;
  } catch (error) {
    console.error("Error occurred while fetching partners:", error);
    return [];
  }
};

export const ReportDaily = async (
  userId: string,
  partnersId: string,
  date: string,
  status: string
): Promise<Reports | null> => {
  try {
    const response = await apiContext.post<Reports>(
      `${ENDPOINT.GENERATEDAILY}`,
      {
        userId,
        partnersId,
        date,
        status,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error occurred while fetching currencies:", error);
    return null;
  }
};

export const ReportDateRange = async (
  userId: string,
  partnersId: string,
  from: string,
  to: string,
  status: string
): Promise<Reports | null> => {
  try {
    const response = await apiContext.post<Reports>(
      `${ENDPOINT.GENERATEDATERANGE}`,
      {
        userId,
        partnersId,
        from,
        to,
        status,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error occurred while fetching currencies:", error);
    return null;
  }
};

export const SSOLogin = async () => {
  const response = await apiContext.get<LoginInternalLink>(
    `${ENDPOINT.SSOLINK}`
  );
  return response.data;
};

export const LoginAuth = async (
  authCode: string
): Promise<LoginAuthInterface | null> => {
  const response = await apiContext.post(`${ENDPOINT.SSOAUTH}`, {
    authCode,
  });
  return response.data;
};

export const BEVersion = async (): Promise<string | null> => {
  const response = await apiContext.get(`${ENDPOINT.VERSION}`);
  return response.data.version;
};

export const GenerateOtp = async (userId: string, type: string) => {
  const response = await apiContext.post(`${ENDPOINT.GENERATEOTP}`, {
    userId,
    type,
  });
  return response.data;
};

export const validateOtp = async (
  userId: string,
  type: string,
  oneTimePin: string
) => {
  const response = await apiContext.post(`${ENDPOINT.VALIDATEOTP}`, {
    userId,
    type,
    oneTimePin,
  });
  return response.data;
};

export const patchNote = async () => {
  const response = await apiContext.get<PatchNote>(`${ENDPOINT.PATCHNOTES}`);
  return response.data;
};

export const balance = async (partnersId: number) => {
  const response = await apiContext.post(`${ENDPOINT.BALANCE}`, {
    partnersId,
  });
  return response.data;
};

export const resetPassword = async (
  userId: string,
  questionId: number,
  answer: string
) => {
  const response = await apiContext.post(`${ENDPOINT.RESETPASSOWRD}`, {
    userId,
    questionId,
    answer,
  });
  return response.data;
};

export const forgetPassword = async (userId: string) => {
  const response = await apiContext.post(`${ENDPOINT.FORGETPASSWORD}`, {
    userId,
  });
  return response.data;
};

export const validatePassword = async (
  userId: string,
  questionId: number,
  answer: string
) => {
  const response = await apiContext.post(`${ENDPOINT.VALIDATEPASSWORD}`, {
    userId,
    questionId,
    answer,
  });
  return response.data;
};

export const updatePassword = async (
  userId: string,
  password: string,
  newPassword: string
) => {
  const response = await apiContext.post(`${ENDPOINT.UPDATEPASSWORD}`, {
    userId,
    password,
    newPassword,
  });
  return response.data;
};

export const updateTheme = async (userId: string, theme: string) => {
  const response = await apiContext.post(`${ENDPOINT.UPDATETHEME}`, {
    userId,
    theme,
  });
  return response.data;
};

export const QuestionList = async (userId: string) => {
  const response = await apiContext.post(`${ENDPOINT.QUESTIONLIST}`, {
    userId,
  });
  return response.data;
};

export const AddQnA = async (userId: string, qandAInfo: QnARequestArray) => {
  const response = await apiContext.post(`${ENDPOINT.ADDQnA}`, {
    userId,
    qandAInfo,
  });
  return response.data;
};

export const UpdateQnA = async (
  userId: string,
  updateQandAInfo: UpdateQnARequestArray
) => {
  const response = await apiContext.post(`${ENDPOINT.UPDATEQnA}`, {
    userId,
    updateQandAInfo,
  });
  return response.data;
};

export const BatchNumberLookUp = async (
  userId: string,
  batchNumber: string,
  partnersId: number
) => {
  const response = await apiContext.post(`${ENDPOINT.BATCHNUMBER}`, {
    userId,
    batchNumber,
    partnersId,
  });
  return response.data;
};

export const trackBatchNumberLookUp = async (
  userId: string,
  batchNumber: string,
  partnersId: number
) => {
  const response = await apiContext.post(`${ENDPOINT.TRACKAPPROVER}`, {
    userId,
    batchNumber,
    partnersId,
  });
  return response.data;
};

export const UserQuestion = async (userId: string) => {
  const response = await apiContext.post(`${ENDPOINT.USERQUESTION}`, {
    userId,
  });
  return response.data;
};

export const batchNumberReport = async (
  userId: string,
  batchNumber: string,
  partnersId: string,
  status: string
) => {
  const response = await apiContext.post(`${ENDPOINT.SENDBATCHNUMBER}`, {
    userId,
    batchNumber,
    partnersId,
    status,
  });
  return response.data;
};

export const ReportsRedirection = async (userId: string) => {
  const response = await apiContext.post(`${ENDPOINT.AUTHLOGIN}`, {
    userId,
  });

  return response.data;
};

export const GetApprovers = async ({
  userId,
  partnersId,
  batchNumber,
}: ApiRequest) => {
  const response = await apiContext.post(`${ENDPOINT.GETAPPROVERS}`, {
    userId,
    partnersId,
    batchNumber,
  });
  return response.data;
};

export const GetApproversPosition = async ({
  userId,
  partnersId,
}: ApiRequest) => {
  const response = await apiContext.post(`${ENDPOINT.GETAPPROVERSPOISITON}`, {
    userId,
    partnersId,
  });
  return response.data;
};

export const GetForApproval = async ({ userId, partnersId }: ApiRequest) => {
  const response = await apiContext.post(`${ENDPOINT.GETFORAPPROVAL}`, {
    userId,
    partnersId,
  });
  return response.data;
};

export const updateForApproval = async ({
  userId,
  partnersId,
  batchNumber,
  isRejected,
  rejectReason,
}: ApiRequest) => {
  const response = await apiContext.post(`${ENDPOINT.UPDATEFORAPPROVAL}`, {
    userId,
    partnersId,
    batchNumber,
    isRejected,
    rejectReason,
  });
  return response.data;
};

export const ApproverStatus = async ({ partnersId, userId }: ApiRequest) => {
  const response = await apiContext.post(`/ApproverStatus`, {
    partnersId,
    userId,
  });
  return response.data;
};

export const MCashStatus = async ({
  userId,
  partnersId,
  batchNumber,
}: ApiRequest) => {
  const response = await apiContext.post(`/MCashStatus`, {
    userId,
    partnersId,
    batchNumber,
  });

  return response.data;
};

export const MCashForceCommit = async ({
  userId,
  partnersId,
  refNoInfo,
}: ApiRequest) => {
  const response = await apiContext.post(`/MCashForceCommit`, {
    userId,
    partnersId,
    refNoInfo,
  });

  return response.data;
};

export const partnerCustomization = async ({
  partnersId,
  systemUse,
}: ApiRequest) => {
  const response = await apiContext.post(`${ENDPOINT.CUSTOMACCOUNT}`, {
    partnersId,
    systemUse,
  });
  return response.data;
};
